import Ajv from 'ajv';

const ajv = new Ajv();

export const schema = {
  type: 'object',
  properties: {
    topic: {
      type: 'string',
      pattern: 'to/classroom/(.+)/register_feedback',
    },
    payload: {
      type: 'object',
      properties: {
        mac: { type: 'string' },
        identifier: { type: 'number' },
        sensor: { type: 'array' },
      },
      required: ['mac', 'identifier'],
    },
  },
  required: ['topic', 'payload'],
  additionalProperties: true,
};

const schemaCheck = ajv.compile(schema);

export const validator = schemaCheck;
